

















































import { Component, Vue, Prop } from "vue-property-decorator";
import { DxToolbarItem } from "devextreme-vue/popup";
import { Project } from "@/data/web-api-client";
import { mapState } from "vuex";
import Datagrid from "@/components/default/Datagrid.vue";
import Popup from "@/components/default/Popup.vue";

@Component({
  components: {
    Popup,
    DxToolbarItem,
    Datagrid,
  },
})
export default class ProjectMatchingProjectsModal extends Vue {
  @Prop({ required: true })
  matchingProjects!: Project[];

  @Prop({ required: true })
  showPopup!: boolean;

  @Prop({ required: false, default: false })
  saving: boolean = false;

  public cellclick(e: any) {
    if (e.column && e.rowType === "data" && e.column.type !== "buttons") {
      this.$router.push({ path: `/projects/${e.data.id}` });
    }
  }

  hide() {
    this.$emit("hide");
  }
  save() {
    this.$emit("create");
  }

  get columns() {
    const self = this;
    return [
      {
        dataField: "projectNumber",
        caption: this.$t("objects.projects.ProjectNumber"),
      },
      {
        dataField: "name",
        caption: this.$t("objects.projects.Name"),
      },
      {
        dataField: "address.addressline1",
        caption: this.$t("objects.address.Addressline1"),
      },
      {
        dataField: "address.addressline2",
        caption: this.$t("objects.address.Addressline2"),
      },
      {
        dataField: "address.zip",
        caption: this.$t("objects.address.Zip"),
      },
      {
        dataField: "address.city",
        caption: this.$t("objects.address.City"),
      },
    ];
  }
}
